import request from '@/utils/request'

// 查询列表
export function apiItemTemplateList (query) {
  return request({
    url: '/mdm/itemTemplate/list',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiMdmItemTemplateNewExport (data) {
  return request({
    url: '/mdm/itemTemplate/v2/export',
    method: 'post',
    data: data
  })
}

// 新增
export function apiItemTemplateAdd (data) {
  return request({
    url: '/mdm/itemTemplate/add',
    method: 'post',
    data: data
  })
}

// 修改
export function apiItemTemplateEdit (data) {
  return request({
    url: '/mdm/itemTemplate/edit',
    method: 'put',
    data: data
  })
}

// 物料模板
export function apiItemTemplatePullDownList (query) {
  return request({
    url: '/mdm/itemTemplate/pullDownList',
    method: 'get',
    params: query
  })
}

// 参数名称
export function apiItemTemplateParameterValueBox (query) {
  return request({
    url: '/mdm/itemTemplate/parameterValueBox',
    method: 'get',
    params: query
  })
}
